import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './Alert.module.scss';

interface AlertProps {
    message?: string;
    className?: string;
}

export const Alert: FunctionComponent<AlertProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <FontAwesomeIcon
                icon={faCircleInfo}
                className={styles.icon}
            />
            <span className={styles.message}>{props.message}</span>
        </div>
    );
};

export default Alert;
